import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService } from 'services/http.service';
import { IntegrationLinkModel } from 'services/models/corporate/integration-link.model';
import { Response } from 'services/models/response';
import { ServiceBase } from 'services/servicebase';

@Injectable()
export class IntegrationLinkService extends ServiceBase<IntegrationLinkModel> {
  constructor(http: HttpService) {
    super('IntegrationLink', http, environment.apiUrl);
  }

  createEntity(input: any): IntegrationLinkModel {
    return IntegrationLinkModel.create(input);
  }

  getAllowedByModule(moduleType: number, movementType: number): Observable<IntegrationLinkModel[]> {
    return this.http
      .get(
        `${this.endpoint}/allowed-by-module?moduleType=${moduleType}&movementType=${movementType}`,
        undefined,
        this.baseUrl,
        undefined,
        true
      )
      .pipe(map(res => (res.body ?? []).map((item: any) => this.createEntity(item))));
  }
}
